import { useEffect, useState } from "react";
import { useBloqueioAdministrativo } from "../../hooks/useBloqueioAdministrativo";
import { IFiltroBloqueioAdministrativo } from "../../interfaces/IFiltroBloqueioAdministrativo";
import { FiltroBloqueioAdministrativo } from "./containers/filtro";
import { ListarLotesBloqueio } from "./containers/lista";
import { ModalCriarLote } from "../CriarLote/containers/ModalCriarLote";
import { IDadosCriarLote } from "../../interfaces/IDadosCriarLote";
import { defaultDadosCriarLote } from "../../constants/defaultDadosCriarLote";
import { lerPlanilha } from "../../constants/lerPlanilha";
import { toastErro } from "components/Toast";
import { IPlanilhaCriarLote } from "../../interfaces/IPlanilhaCriarLote";
import { IOptions } from "components/DropdownSelect";

interface IProps {
  setPagina: (pagina: "LOTES" | "DETALHE" | "CRIAR") => void;
  setLoteEscolhido: (idLote: number | null) => void;
  dadosCriarLote: IDadosCriarLote;
  setDadosCriarLote: (dados: IDadosCriarLote) => void;
  setDadosPlanilhaCriarLote: (dados: IPlanilhaCriarLote[]) => void;
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function LoteBloqueioAdministrativo({
  setPagina,
  setLoteEscolhido,
  dadosCriarLote,
  setDadosCriarLote,
  setDadosPlanilhaCriarLote,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IProps) {
  const [showModalCriarLote, setShowModalCriarLote] = useState<boolean>(false);

  const {
    totalRows,
    page,
    limit,
    loading,
    setPage,
    setLimit,
    listarLotes,
    dadosLotesBloqueio,
    filtro,
    relatorioLotes,
  } = useBloqueioAdministrativo();

  function handlePageChange(page: number) {
    setPage(page);
  }
  function handleLimitChange(limit: number) {
    setLimit(limit);
  }
  const handleVerDetalhes = (idLote: number) => {
    setLoteEscolhido(idLote);
    setPagina("DETALHE");
  };

  const submitFiltro = (dados: IFiltroBloqueioAdministrativo) => {
    listarLotes(dados);
  };

  useEffect(() => {
    listarLotes(filtro);
  }, [page, limit]);

  const handleAbrirModalCriarLote = (acao: "bloquear" | "desbloquear") => {
    setDadosCriarLote({ ...defaultDadosCriarLote, tipo: acao });
    setShowModalCriarLote(true);
  };

  const onClickProsseguir = async () => {
    const leituraPlanilha = await lerPlanilha(dadosCriarLote.arquivo);

    if (leituraPlanilha.temErro) {
      toastErro(leituraPlanilha.mensagemErro);
      return;
    }

    setDadosPlanilhaCriarLote(leituraPlanilha.dados);
    setShowModalCriarLote(false);
    setPagina("CRIAR");
  };

  return (
    <>
      <FiltroBloqueioAdministrativo submitForm={submitFiltro} />
      <ListarLotesBloqueio
        dados={dadosLotesBloqueio}
        handleLimitChange={handleLimitChange}
        handlePageChange={handlePageChange}
        totalRows={totalRows}
        loading={loading}
        linhasPorPagina={limit}
        handleVerDetalhes={handleVerDetalhes}
        onClickBloquear={() => {
          handleAbrirModalCriarLote("bloquear");
        }}
        onClickDesbloquear={() => {
          handleAbrirModalCriarLote("desbloquear");
        }}
        relatorioLotes={relatorioLotes}
      />
      <ModalCriarLote
        dadosCriarLote={dadosCriarLote}
        setDadosCriarLote={setDadosCriarLote}
        show={showModalCriarLote}
        handleClose={() => {
          setShowModalCriarLote(false);
          setDadosCriarLote({ ...defaultDadosCriarLote });
        }}
        onClickProsseguir={onClickProsseguir}
        empresasOptions={empresasOptions}
        cnpjsOptions={cnpjsOptions}
        listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
      />
    </>
  );
}
